import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const AdminRoute = () => {
  const { token, user } = useSelector((s) => s.auth);
  if (!token) return <Navigate to="/signin" replace />;
  if (user?.role !== "admin") return <Navigate to="/sidebar" replace />;
  return <Outlet />;
};

export default AdminRoute;
